import { SrFaxManagementApi, SrfaxQueueFaxRequest } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 *
 * @author Atish Bagate
 */

interface Params {
  faxSend: SrfaxQueueFaxRequest;
  xTENANTID?: string;
}

  export const useAddFaxSend = () =>
  useMutationWithLoading(async (params: Params) =>
    new SrFaxManagementApi(getConfigObject()).queueFax(
      params.faxSend,
      params.xTENANTID
    )
  );
